import PropTypes from 'prop-types';

import Card from '#globalComponents/Card/Card';

import { formatPrice } from '../../../utils/formatters';

const ProductHeader = ({ product }) => (
	<Card className="mx-4 lg:mx-8 mb-3.5 p-0 overflow-hidden">
		<div className="grid items-center gap-4 px-5 py-4" style={{ gridTemplateColumns: '56px 1fr auto' }}>
			<div className="w-14 h-14 rounded-card bg-gradient-to-br from-primary-500 to-primary-600 text-white flex items-center justify-center text-lg font-bold tracking-tight">
				{product.name
					?.split(' ')
					.map((n) => n[0])
					.slice(0, 2)
					.join('')
					.toUpperCase() ?? '?'}
			</div>
			<div className="min-w-0">
				<h1 className="text-lg font-bold text-text tracking-tight truncate">{product.name}</h1>
				{product.articleNumber && (
					<div className="flex items-center gap-1.5 mt-1 text-xs text-bgBase-800">
						<span>Art.-Nr. {product.articleNumber}</span>
					</div>
				)}
			</div>
			<div className="flex gap-4 lg:gap-7 pl-4 lg:pl-6 border-l border-bgBase-500 flex-shrink-0">
				<div className="flex flex-col gap-1">
					<span className="text-[10px] font-semibold uppercase tracking-wider text-bgBase-800">Preis</span>
					<span className="text-lg font-bold text-text tabular-nums">
						{formatPrice(product.price) || '–'}
					</span>
				</div>
			</div>
		</div>
	</Card>
);

ProductHeader.propTypes = {
	product: PropTypes.object.isRequired,
};

export default ProductHeader;
